"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapActionWithDispatch = wrapActionWithDispatch;
function wrapActionWithDispatch(dispatch, action) {
  return (...args) => dispatch(action(...args));
}
